import { breakpoints } from "@olmokit/core/scss";
import { $, $all, on, forEach } from "@olmokit/dom";
import gsap from "gsap";
import { post } from "@olmokit/core/fragments/ajax";
import { WindowDetect } from "components/WindowDetect";
import { CardProduct, CardProductProps } from "components/CardProduct";
// import LazyLoad from "@olmokit/core/lazy";
import { render } from "@olmokit/utils/render";
// import "@olmokit/core/forms/checkbox";
import "./index.scss";

const renderCardProduct = render($("#card-product").innerHTML);

/**
 * Component: Filters 
 */
export function Filters(urlrequest) {
  console.log("Filters mounted.");

  // console.log(breakpoints.lg);
  const sizeMenu = WindowDetect() >= breakpoints.lg ? 'auto' : '100%';

  FiltersToLoadingPage(urlrequest);
  PropertyOption(urlrequest);
  // MinOpen();

  //-------------------------
  // Open close filters
  //-------------------------

  const icons = $('.Filters:icons');
  const minus = $('.Filters:icons_minus');
  const plus = $('.Filters:icons_plus');
  const background = $('.Filters:bg');

  const iconsMobile = $('.Filters:bg_icon');

  if(sizeMenu == '100%'){
    plus.classList.add('is-active');
  }  else {
    minus.classList.add('is-active');
  }

  on(iconsMobile, 'click', () => {
    gsap.to(background, { duration: 0.3, height: 0 });
    // gsap.to(iconsMobile, { duration: 0.3, top: '-50px' });
    plus.classList.add('is-active');
    minus.classList.remove('is-active');
    $('body').style.overflow = 'initial';
  });

  on(icons, 'click', (e) => {
    e.preventDefault();
    if(minus.classList.contains('is-active')){
      plus.classList.add('is-active');
      minus.classList.remove('is-active');
      gsap.to(background, { duration: 0.3, height: 0 });
    } else {
      plus.classList.remove('is-active');
      minus.classList.add('is-active');
      gsap.to(background, { duration: 0.3, height: sizeMenu });
      // gsap.to(iconsMobile, { duration: 0.3, top: '15px' });
      if(sizeMenu == '100%'){
        $('body').style.overflow = 'hidden';
      }
    }    
  });

}

/* Open minimal dropdown */
export function MinOpen() {
  const openMins = $all('.CardProduct:minimal');
  if (openMins) {
    document.addEventListener('click', function (event) {
      if (event.target.classList.contains('CardProduct:minimal')) {
        event.target.classList.add('CardProduct:minimal--open');
      }
    })
  }
}

  /** 
   * Setup the property store 
   * */
  let property = {};

/**
 * This function manage the click on the property value
 * if the class is-filter is in the filter means the filter is active
 * so remove the class by clicking viceversa add it
 */
export function PropertyOption(urlrequest) {

  const filters = $all('.Filters:property_value');

  forEach(filters, (el) => {
    on(el, 'click', (e) => {

      e.preventDefault();
      const filter = $('.Filters:property_value-checkbox', el);
      const id = filter.getAttribute('data-id');
      const value = filter.getAttribute('value');

      if(!el.classList.contains('is-filter')){

        el.classList.add('is-filter');
        
        /** Push value in the store and set params */   
        filtersData('add', el.getAttribute('data-property'), el.getAttribute('data-filter'));
        storeProperty('add', id, value);
        setParams('add', id, property[id]);

      } else {

        el.classList.remove('is-filter');

        /** Push value in the store and set params */   
        filtersData('remove', el.getAttribute('data-property'), el.getAttribute('data-filter'));
        storeProperty('remove', id, value);
        setParams('remove', id, property[id]);

      }

      productRefresh(property, urlrequest);

    });
  });  

}

/**
 * This function manage the filters activation by loading the page
 * if the params are in the url
 */
export function FiltersToLoadingPage(urlrequest) {

  let url = window.location.href;
  let urlUrl = new URL(url);
  let params = new URLSearchParams(urlUrl.search.slice(1));  

  const filters = $all('.Filters:property_value');

  let array;
  let valuesObj = [];
  let val = {};

  for (let p of params) {    

    val[p[0]] = p[1];
    let rawArray = JSON.parse("[" + p[1] + "]");
    val[p[0]] = rawArray;
    array = rawArray;

    property = val;

    forEach(filters, (el) => {
      const filter = $('.Filters:property_value-checkbox', el);
      const id = filter.getAttribute('data-id');
      const value = filter.getAttribute('value');

      if (array.includes(parseInt(value))) {
        el.classList.add('is-filter');

        if (!valuesObj[id]) {
          valuesObj[id] = [value];
        } else {
          valuesObj[id].push(value);
        }
      }
    });

  }

  if(valuesObj.length > 0){
    productRefresh(valuesObj, urlrequest);
  }

}

export function storeProperty(type, id, value) {
  if(type == 'add'){
    if(property[id]){
      property[id].push(value);
    } else {
      property[id] = [value];
    }
  } else if(type == 'remove') {    
    const size = Object.keys(property).length;
    if(size == 1 && property[id].length == 0){
      property = [];
    } else {
      const arr = property[id].filter((e) => e != value);
      property[id] = arr;
      if(property[id].length == 0) {
        delete property[id];
      }
    }
  }  
}

export function setParams(type, name, value) {
  let url = window.location.href;
  let urlUrl = new URL(url);
  let params = new URLSearchParams(urlUrl.search.slice(1));

  const size = Object.keys(property).length;

  if(type == 'add'){
    /** Just add a param */
    params.set(name, value);
    window.history.replaceState({}, "", `${location.pathname}?${params}`);
  } else {
    /** Check if there is no value */
    if(size == 0){
      window.history.replaceState({}, "", `${location.pathname}`);
    } else {
      /** 
       * Check if the value is true means the property still has value 
       * otherwise delete the property
       * */
      if(value){
        params.set(name, value);
      } else {
        params.delete(name);
      }
      window.history.replaceState({}, "", `${location.pathname}?${params}`);
    }
  }
}

export function productRefresh(data, urlrequest) {  

  let queryValues = [];
 
  for (const [key, value] of Object.entries(data)) {
    queryValues.push(JSON.parse("[" + value + "]"));
  }

  const $products = $(".Products:results");
  const pasteNumber = $('.Filters:title_num-val');
  const loader = $('.Loader:');

  loader.style.display = 'block';

  post(urlrequest+'/', {
    data: {
      id: JSON.stringify(queryValues),
    },
  }).then(({ data }) => {
    // $products.innerHTML = data;
    $products.innerHTML = renderCardProduct({
      results: data.elements
    });

    // new LazyLoad();

    const $noResult = $(".Noresult:");
    if(data.counter == 0){
      $noResult.style.display = "block";
    } else {
      $noResult.style.display = "none";
    }
    // pasteNumber.innerHTML = $productsList.getAttribute('data-number');
    pasteNumber.innerHTML = data.elements.length;

    loader.style.display = 'none';

    // MinOpen();
    CardProduct(); 
    CardProductProps();

    // disableProperty();
  });
}

export function disableProperty() {
  const values = $all('.Filters:property_value');
  const productsValids = $(".Products:").getAttribute('data-valids');
  let valids = productsValids.split(',');

  forEach(values, (el) => {
    el.classList.add('is-notactive');
  });
  
  forEach(values, (el) => {

    const filter = $('.Filters:property_value-checkbox', el);
    const value = filter.getAttribute('value');

    if(valids.includes(value)){
      el.classList.remove('is-notactive');
    }

  });
}

export function filtersData(action, category, name) {
  dataLayer.push({
    'event': 'filter',
    'filter_category': category,
    'filter_name': name,
    'action': action, 
  });   
}